export const GetCurrentUser = (api) => {
    return api.get("/api/v1/Account/User")
}

export const GetUserPassword = (api) => {
    return api.get("/api/v1/Account/getUserPassword")
}

export const UpdateAcceptedAgreementsVersion = (api, userId, accepptedAgreementsVersion) => {
    return api.post(`/api/v1/Account/updateAcceptedAgreementsVersion?userId=${userId}&agreementsVersion=${accepptedAgreementsVersion}`, null)
}